
export {initSession};

var setWatcher = ''

function initSession() {
    return new Promise((resolve) => { 
        var access_Token = localStorage.getItem("access_token")
        if (access_Token != null && access_Token != "" && access_Token != undefined) {
            // var decodedAccessToken = JSON.parse(atob(access_Token.split('.')[1]));
            var decodedAccessToken = access_Token.split('.')[1];
            let base64 = decodedAccessToken.replace('-', '+').replace('_', '/');
            let decodedData = JSON.parse(Buffer.from(base64, 'base64').toString('binary'));
            // let expDateTime = decodedData.exp
            // let expInminutes = Math.floor(expDateTime / 60000);
            let expDateTime = new Date(decodedData.exp * 1000)
            let currentDateTime = new Date()
            let diff = expDateTime - currentDateTime
            let diffInminutes = Math.floor(diff / 60000);
            let thirtyMinutesBeforeExpiry = diffInminutes - 30; 
            let thirtyMinutesBeforeExpiryInMilliSecs = thirtyMinutesBeforeExpiry * 60000
            session.isTimeOutSet = true
            setTimeout(watcherForEveryMinute,thirtyMinutesBeforeExpiryInMilliSecs); //setTimeout before 30 mins
        }
    })
      
}

function watcherForEveryMinute() { 
    setWatcher = window.setInterval(() => { 
        checkExpirationOfAccessToken()
       }, 60000) // watcher for every one min
}
function checkExpirationOfAccessToken(){ 
    var access_Token = localStorage.getItem("access_token")
       if (access_Token != null && access_Token != "" && access_Token != undefined) {
           // var decodedAccessToken = JSON.parse(atob(access_Token.split('.')[1]));
           var decodedAccessToken = access_Token.split('.')[1];
           let base64 = decodedAccessToken.replace('-', '+').replace('_', '/');
           let decodedData = JSON.parse(Buffer.from(base64, 'base64').toString('binary'));
           let expDateTime = new Date(decodedData.exp * 1000)
           let currentDateTime = new Date()
           let diff = expDateTime - currentDateTime
           let minutes = Math.floor(diff / 60000);
           let getLastActiveTime = localStorage.getItem("LastActivityTime")
           let lastPageLoadTime = new Date(getLastActiveTime)
           let idleTime = currentDateTime - lastPageLoadTime
           let idleTimeDiffInSecs = Math.floor(idleTime / 1000)
          // if(diff <= 120000){ // diff in ms
             if(idleTimeDiffInSecs > 61200){ //idle time diff in sec
               ajax.signOut()
             }else{
               if(session.isRefreshTokenAPIInProgress == false){
                //  doRefreshToken()
                ajax.signOut()
               }
              
             }

       }
   }
  function doRefreshToken(){ 
       session.isRefreshTokenAPIInProgress = true
         let refresh_token = localStorage.getItem("refresh_token")

       var requestBody = new URLSearchParams()
       requestBody.append('grant_type', 'refresh_token')
       requestBody.append('RefreshToken', refresh_token)

       const config = {
           headers: {
               'Content-Type': 'application/x-www-form-urlencoded'
           }
       }
        axios.post("/RefreshToken", requestBody, config).then((res) => {
           if(res && res.data != null){
               window.clearInterval(setWatcher);
                 ajax.saveToken(res.data.access_token, res.data.refresh_token)
                 //error.config.headers.Authorization = `Bearer ${res.data.access_token}`
                 var token = res.data.access_token
                 var base64Url = token.split('.')[1];
                 var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                 var jsonPayload = decodeURIComponent(Buffer.from(base64, "base64").toString("ascii").split("").map(function(c) {
                 return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                   }).join(''));

                var decodedAccessToken = JSON.parse(jsonPayload)
                localStorage.setItem("expiry_date", new Date(decodedAccessToken.exp * 1000))
                session.isRefreshTokenAPIInProgress = false
                session.isTimeOutSet = false
        
                let expDateTime = new Date(decodedAccessToken.exp * 1000)
                let currentDateTime = new Date()
                let diff = expDateTime - currentDateTime
                let diffInminutes = Math.floor(diff / 60000);
                let thirtyMinutesBeforeExpiry = diffInminutes - 30; 
                let thirtyMinutesBeforeExpiryInMilliSecs = thirtyMinutesBeforeExpiry * 60000
                session.isTimeOutSet = true
                setTimeout(watcherForEveryMinute,thirtyMinutesBeforeExpiryInMilliSecs);
                 // session.isRefreshTokenAPIInProgress = false
                 // window.location.reload();
                 //return axios.request(error.config)
           }else{
                session.isRefreshTokenAPIInProgress = false
                session.isTimeOutSet = false
                ajax.signOut()
                return Promise.reject(error)
            }
        }).catch(error => { 
            session.isRefreshTokenAPIInProgress = false
            ajax.signOut()
            return Promise.reject(error)
        });

   }



// WEBPACK FOOTER //
// ./src/components/Core/session-manager.js